/* MAMEIDO Testimonials: Zusatz-Effekte (siehe assets/mameido-testimonials-pep.css)
   1) Einblenden nacheinander, sobald der Baustein ins Bild scrollt.
   2) Fotos wandern beim Scrollen leicht mit, abwechselnd nach oben und unten (sehr dezent).
   Bei "Bewegung reduzieren" oder ohne Script bleibt alles ruhig und sofort sichtbar. */
(function () {
  'use strict';

  if (window.mameidoTestimonialsPep) return;

  var DRIFT = 0;       // Mitwandern beim Scrollen ist abgeschaltet (vorher 12 px)
  var EASE = 0.12;     // Glättung
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var roots = [];
  var queued = false;
  var io = null;

  function clamp(v, min, max) { return Math.min(max, Math.max(min, v)); }

  function slidesOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.mameido-testimonials-slide'));
  }

  /* Karussell nur, wenn es nötig ist.
     Passen alle Karten bequem nebeneinander auf den Bildschirm (große Desktops), gibt es nichts zu wischen: Das Script
     schaltet das Theme-Karussell (Flickity) dann ab, und die Karten stehen mit engem Abstand mittig in einer Reihe.
     Das vermeidet auch Lücken und doppelte Karten, die ein Karussell mit wenigen, schmalen Karten sonst zeigt.
     Wird das Fenster schmaler, startet das Karussell wieder (mit denselben Einstellungen wie vorher). */
  function adaptCarousel(root) {
    var slider = root.querySelector('.testimonials-slider');
    if (!slider || !window.Flickity || !Flickity.data) return;
    var saved = null;

    function baseWidth() {
      var slide = slider.querySelector('.testimonials-slide');
      if (!slide) return 0;
      var cs = window.getComputedStyle(slide);
      var img = parseFloat(window.getComputedStyle(root).getPropertyValue('--tq-w')) || 200;
      return img + 8 + (parseFloat(cs.marginLeft) || 0) + (parseFloat(cs.marginRight) || 0);
    }

    function fits() {
      var count = slider.querySelectorAll('.testimonials-slide').length;
      var wrapper = root.querySelector('.slideshow-wrapper') || root;
      return count * baseWidth() <= wrapper.clientWidth;
    }

    function evaluate() {
      var flk = Flickity.data(slider);
      if (flk) {
        if (window.innerWidth >= 769 && fits()) {
          saved = flk.options;
          flk.destroy();
          root.classList.add('mtq-static');
        }
        return true;
      }
      if (root.classList.contains('mtq-static') && !fits()) {
        root.classList.remove('mtq-static');
        if (saved) new Flickity(slider, saved);
      }
      return false;
    }

    // Das Theme startet das Karussell erst, wenn der Baustein fast sichtbar ist: kurz warten, bis es läuft.
    var tries = 0;
    var wait = window.setInterval(function () {
      tries += 1;
      if (evaluate() || tries > 100) window.clearInterval(wait);
    }, 300);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(evaluate, 500);
    }, { passive: true });
  }

  function setup(root) {
    if (root.__pep) return;
    var entry = { root: root, cur: [], tgt: [] };
    root.__pep = entry;
    roots.push(entry);

    adaptCarousel(root);

    slidesOf(root).forEach(function (slide, i) {
      slide.style.setProperty('--pep-i', i);
    });

    if (reduce || !('IntersectionObserver' in window)) return;

    root.classList.add('pep-ready');
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('pep-in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    io.observe(root);

    // Sicherheitsnetz: nie dauerhaft unsichtbar bleiben (z. B. bei seltsamem Scroll-Verhalten im Editor)
    window.setTimeout(function () { root.classList.add('pep-in'); }, 6000);
  }

  function measure(entry) {
    var vh = window.innerHeight || 800;
    var rect = entry.root.getBoundingClientRect();
    if (rect.bottom < -200 || rect.top > vh + 200) return false;
    var p = clamp(((rect.top + rect.height / 2) - vh / 2) / (vh / 2 + rect.height / 2), -1, 1);
    var scale = window.innerWidth < 769 ? 0.6 : 1;
    slidesOf(entry.root).forEach(function (slide, i) {
      var dir = i % 2 === 0 ? 1 : -1;
      var depth = i % 3 === 1 ? 0.7 : 1;
      entry.tgt[i] = p * DRIFT * dir * depth * scale;
      if (entry.cur[i] === undefined) entry.cur[i] = entry.tgt[i];
    });
    return true;
  }

  function apply(entry) {
    slidesOf(entry.root).forEach(function (slide, i) {
      var img = slide.querySelector('.testimonial-image');
      if (img) img.style.setProperty('--pep-y', (entry.cur[i] || 0).toFixed(2));
    });
  }

  function tick() {
    queued = false;
    var moving = false;
    roots.forEach(function (entry) {
      if (!measure(entry)) return;
      entry.tgt.forEach(function (t, i) {
        var d = t - entry.cur[i];
        if (Math.abs(d) < 0.05) { entry.cur[i] = t; } else { entry.cur[i] += d * EASE; moving = true; }
      });
      apply(entry);
    });
    if (moving) schedule();
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(tick);
  }

  // Sofort (ohne Glättung): erster Aufbau und Test
  function update(instant) {
    roots.forEach(function (entry) {
      if (!measure(entry)) return;
      if (instant) entry.cur = entry.tgt.slice();
      apply(entry);
    });
    if (!instant) schedule();
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.mameido-testimonials'), setup);
    update(true);
  }

  // Handy (kein Darüberfahren möglich): Antippen eines Bildes zeigt das Zitat, erneutes Antippen oder ein anderes Bild
  // schließt es wieder. Nach einem Wischen im Karussell löst das Theme keinen Klick aus.
  document.addEventListener('click', function (event) {
    var frame = event.target.closest ? event.target.closest('.mtq-frame') : null;
    var open = document.querySelectorAll('.mtq-frame.is-open');
    Array.prototype.forEach.call(open, function (el) { if (el !== frame) el.classList.remove('is-open'); });
    if (!frame || !frame.querySelector('.mtq-overlay')) return;
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) return;
    frame.classList.toggle('is-open');
  });

  window.mameidoTestimonialsPep = { update: update };

  init();
  // Kein Mitwandern der Fotos beim Scrollen mehr (war nur ein Test-Effekt): keine Scroll-Beobachtung.

  // Theme-Editor: Baustein wird neu geladen oder neu hinzugefügt
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
